import { Shadow, HStack, VStack } from '@genial/components';
import { BoxRadius, Color, Typography } from '@genial/design-tokens';
import { Skeleton } from 'native-base';
import React from 'react';

export const LoadingItemMobile: React.FC = () => {
  return (
    <Shadow level={2} borderRadius={BoxRadius.sm} testId="customer-table-list">
      <VStack p="inline.xxs" borderRadius={BoxRadius.sm} space="inline.xxxs" flex={1}>
        <HStack alignItems={'center'} justifyContent={'space-between'}>
          <VStack w="3/5">
            <Skeleton
              w={'65%'}
              h={Typography['fontsize.md']}
              borderRadius={BoxRadius.sm}
              endColor={Color['brand.primary.lightest']}
            />
            <Skeleton
              w={'20%'}
              h={Typography['fontsize.xs']}
              borderRadius={BoxRadius.sm}
              endColor={Color['brand.primary.lightest']}
            />
          </VStack>
          <HStack alignItems={'center'} space="inline.nano">
            <Skeleton
              w={'24px'}
              h={'24px'}
              borderRadius={'full'}
              endColor={Color['brand.primary.lightest']}
            />
            <Skeleton
              w={'24px'}
              h={'24px'}
              borderRadius={'full'}
              endColor={Color['brand.primary.lightest']}
            />
          </HStack>
        </HStack>
        <VStack space="stack.nano">
          <HStack justifyContent="space-between">
            <Skeleton
              w={'40%'}
              h={Typography['fontsize.md']}
              borderRadius={BoxRadius.sm}
              endColor={Color['brand.primary.lightest']}
            />

            <Skeleton
              w={'40%'}
              h={Typography['fontsize.md']}
              borderRadius={BoxRadius.sm}
              endColor={Color['brand.primary.lightest']}
            />
          </HStack>
          <HStack justifyContent="space-between">
            <Skeleton
              w={'40%'}
              h={Typography['fontsize.md']}
              borderRadius={BoxRadius.sm}
              endColor={Color['brand.primary.lightest']}
            />

            <Skeleton
              w={'40%'}
              h={Typography['fontsize.md']}
              borderRadius={BoxRadius.sm}
              endColor={Color['brand.primary.lightest']}
            />
          </HStack>
        </VStack>
        <HStack w={'full'} justifyContent={'space-between'} alignItems={'center'}>
          <VStack maxW={'100px'} flex={1} space="inline.quarck">
            <Skeleton
              w={'full'}
              h={Typography['fontsize.md']}
              borderRadius={BoxRadius.sm}
              endColor={Color['brand.primary.lightest']}
            />

            <Skeleton
              w={'80%'}
              h={Typography['fontsize.md']}
              borderRadius={BoxRadius.sm}
              endColor={Color['brand.primary.lightest']}
            />
          </VStack>
          <Skeleton
            w={'147px'}
            h={'38px'}
            borderRadius={'full'}
            endColor={Color['brand.primary.lightest']}
          />
        </HStack>
      </VStack>
    </Shadow>
  );
};
